import { createAsyncThunk } from '@reduxjs/toolkit';
import { wowsCommerceReducerActions } from './wowsCommerceSlice';
import { wowsCommerce, STOREFRONT_NAME } from '~/wowsCommerce';


// Reducer actions
export const {
    setShopLoadingState
} = wowsCommerceReducerActions;


// Thunk actions
export const loadProducts = createAsyncThunk('wowsCommerce/loadProducts', async () => {
    const products = await wowsCommerce?.products(STOREFRONT_NAME);
    return products;
});
